import _extends from "@babel/runtime/helpers/extends";

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React, { useContext, useMemo } from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import Badge from "../../Badge";
import HsTree from "../HsTree";
import Context from "../context";
import AvailabilityBadge from "../../AvailabilityBadge/AvailabilityBadge";
import { isCodePartOf } from "../utils";
import styles from "./Child.module.css";

const TreeChild = _ref => {
  let {
    children,
    isSubChild,
    isRtl,
    ...props
  } = _ref;
  const {
    verticalLinePosition
  } = useContext(Context);
  return /*#__PURE__*/React.createElement("li", _extends({
    className: cx(styles.treeChild, styles.verticalLine, {
      [styles.subChild]: isSubChild,
      [styles.rtl]: isRtl
    }),
    style: {
      "--vertical-line-position-left": "".concat(-verticalLinePosition, "px")
    }
  }, props), children);
};

__signature__(TreeChild, "useContext{{ verticalLinePosition }}");

TreeChild.propTypes = {
  children: PropTypes.node.isRequired,
  isSubChild: PropTypes.bool,
  isRtl: PropTypes.bool
};
TreeChild.defaultProps = {
  isSubChild: false,
  isRtl: false
};

const HsTreeChild = _ref2 => {
  var _codeDetails$children;

  let {
    codeDetails,
    children,
    searchCode,
    size,
    isRtl,
    isSubChild,
    ...childProps
  } = _ref2;
  const code = codeDetails.shortCode || codeDetails.code;
  const {
    colors
  } = useContext(Context);
  const isCodePartOfSearhCode = useMemo(() => isCodePartOf(code, searchCode), [code, searchCode]);
  const {
    t
  } = useTranslation();

  if (children) {
    return /*#__PURE__*/React.createElement(TreeChild, {
      isSubChild: isSubChild,
      isRtl: isRtl
    }, children);
  }

  return codeDetails.children ? /*#__PURE__*/React.createElement(HsTreeChild, {
    isRtl: isRtl,
    size: size,
    isSubChild: true
  }, /*#__PURE__*/React.createElement(HsTree, {
    isRtl: isRtl,
    title: codeDetails.isFilled ? codeDetails.description : null,
    isSubTree: true,
    colors: colors
  }, (_codeDetails$children = codeDetails.children) === null || _codeDetails$children === void 0 ? void 0 : _codeDetails$children.map((childCode, idx) =>
  /*#__PURE__*/
  // eslint-disable-next-line react/no-array-index-key
  React.createElement(HsTreeChild, {
    isRtl: isRtl,
    key: childCode.code + idx,
    codeDetails: childCode,
    size: size,
    isSubChild: true
  })))) : /*#__PURE__*/React.createElement(TreeChild, _extends({
    isRtl: isRtl
  }, childProps), /*#__PURE__*/React.createElement(AvailabilityBadge, {
    isExist: codeDetails.isRestricted || codeDetails.isProhibited,
    isProhibited: codeDetails.isProhibited,
    className: cx(styles.availabilityBadge, {
      [styles.rtl]: isRtl
    })
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.childBadge
  }, /*#__PURE__*/React.createElement(Badge, {
    color: isCodePartOfSearhCode ? colors.success : colors.secondary,
    size: size
  }, code)), /*#__PURE__*/React.createElement("div", {
    className: cx(styles.treeItemDetails, {
      [styles.rtl]: isRtl
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.label
  }, codeDetails.description, codeDetails.isProhibited && /*#__PURE__*/React.createElement("span", {
    className: styles.availabilityLabel
  }, "(".concat(t("Prohibited"), ")")), codeDetails.isRestricted && /*#__PURE__*/React.createElement("span", {
    className: styles.availabilityLabel
  }, "(".concat(t("Restricted by", {
    value: codeDetails.restrictionAuthority
  }), ")")))));
};

__signature__(HsTreeChild, "useContext{{ colors }}\nuseMemo{isCodePartOfSearhCode}\nuseTranslation{{ t }}", () => [useTranslation]);

HsTreeChild.propTypes = {
  codeDetails: PropTypes.shape({
    code: PropTypes.string,
    shortCode: PropTypes.string,
    description: PropTypes.string,
    children: PropTypes.array,
    isProhibited: PropTypes.bool,
    isRestricted: PropTypes.bool,
    restrictionAuthority: PropTypes.string,
    isFilled: PropTypes.bool
  }),
  children: PropTypes.element,
  searchCode: PropTypes.string,
  isSubChild: PropTypes.bool,
  size: PropTypes.oneOf(["sm", "md"]),
  isRtl: PropTypes.bool
};
HsTreeChild.defaultProps = {
  codeDetails: {},
  children: null,
  searchCode: null,
  isSubChild: false,
  size: "md",
  isRtl: false
};

const _default = /*#__PURE__*/React.memo(HsTreeChild);

export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(TreeChild, "TreeChild", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/components/HsCodesTree/Child/Child.jsx");
  reactHotLoader.register(HsTreeChild, "HsTreeChild", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/components/HsCodesTree/Child/Child.jsx");
  reactHotLoader.register(_default, "default", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/components/HsCodesTree/Child/Child.jsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();